import * as React from "react"
import {AutocompleteAjaxSeeker} from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import {customerSelectedID} from "@signals";

export default function DIPCustomer({ options, ...props }) {

    return <AutocompleteAjaxSeeker
        urlAjax={`${BACKEND_APIS.MANAGEMENT}/keywords/customer-options`}
        label="Customer"
        placeholder="All Customers..."
        multiple
        value={customerSelectedID.value}
        onChange={e => customerSelectedID.value = e.target.value}
        {...props}
    />
}